// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__usyMt","controls":"styles_controls__1DrIc","charLimit":"styles_charLimit__1iZo7","input":"styles_input__1ISuj","send":"styles_send__198Dh"};